export class Pregnancy {
  dt?: string;
  firstname?: string;
  coding_id?: number;
  patient_id?: number;
  expected_date_of_delivery?: string;
  description?: string;
  version_id?: number;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
